import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from "gsap/CustomEase";
import Swiper from 'swiper/bundle';
import Lenis from '@studio-freight/lenis';
// import Swup from 'swup';
// import SwupDebugPlugin from '@swup/debug-plugin';
import Lottie from 'lottie-web';

/*-------------------------------------
 Lenis設定（スムーススクロール）
--------------------------------------*/
const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);


/*-------------------------------------
 スクロール時の処理
--------------------------------------*/
let startPos = 0;
let winScrollTop = 0;
let threshold = window.innerHeight * 0.5;
const topSliderEl = document.getElementById('topSlider');

window.addEventListener('scroll', () => {
  winScrollTop = window.scrollY;

  if (topSliderEl) {
    const topSliderHeight = topSliderEl.offsetHeight;
    if (winScrollTop >= topSliderHeight) {
      document.body.classList.add('is-scroll-toppage');
    } else {
      document.body.classList.remove('is-scroll-toppage');
    }
  } else {
    document.body.classList.remove('is-scroll-toppage');
  }

  if (winScrollTop !== 0) {
    document.body.classList.add('is-scroll');
  } else {
    document.body.classList.remove('is-scroll');
  }

  if (winScrollTop >= startPos) {
    if (winScrollTop >= threshold) {
      document.body.classList.add('is-down');
    }
  } else {
    document.body.classList.remove('is-down');
  }
  startPos = winScrollTop;
});
window.addEventListener('resize', () => {
  threshold = window.innerHeight;
});

/*-------------------------------------
 GSAP ScrollTrigger
--------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

function createScrollTrigger(selector, start, className, markers = false, pin = false) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: start,
      toggleClass: { targets: el, className: className },
      once: true,
      markers: markers,
			pin: pin,
    });
  });
}

/*-------------------------------------
 メニュー開閉・トグル関連
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  createScrollTrigger('.fadeUp','top 75%','is-active');
  document.body.classList.add('is-ready');
  
  const menuButton = document.getElementById('menuButton');
  const gnav = document.getElementById('gnav');
  let isMenuOpen = false;
  let scrollPos = 0;

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('show');
    gnav.classList.toggle('show');
    if (!isMenuOpen) {
      scrollPos = window.scrollY;
      document.body.classList.add('fixed');
      document.body.style.top = `-${scrollPos}px`;
      isMenuOpen = true;
    } else {
      closeMenu();
    }
  });

  function closeMenu() {
    menuButton.classList.remove('show');
    gnav.classList.remove('show');
    document.body.classList.remove('fixed');
    document.body.style.top = '0';
    window.scrollTo(0, scrollPos);
    isMenuOpen = false;
  }

  Array.from(gnav.querySelectorAll('a')).forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // メニュー以外をクリックしたら閉じる
  document.addEventListener('click', (e) => {
    if (!gnav.contains(e.target) && !menuButton.contains(e.target) && isMenuOpen) {
      closeMenu();
    }
  });

  // リサイズ対応
  function handleResize() {
    if (window.innerWidth >= 768) {
      document.body.classList.remove('fixed');
      document.body.style.top = '0';
    }
  }
  window.addEventListener('load', handleResize);
  window.addEventListener('resize', handleResize);

  /*-------------------------------------
   ページトップボタン
  --------------------------------------*/
  const pagetopA = document.getElementById('pagetopA');
  const pagetopB = document.getElementById('pagetopB');
  if (pagetopA && pagetopB) {
    pagetopA.addEventListener('click', () => {
      lenis.scrollTo(0);
    });
    pagetopB.addEventListener('click', () => {
      lenis.scrollTo(0);
    });
    window.addEventListener('scroll', (e) => {
      const scrollTop = window.pageYOffset;
      const footer = document.querySelector('footer');
      
      // スクロールが20pxを超えたらis-scrollクラスを追加
      if (scrollTop >= 20) {
        pagetopA.classList.add('is-scroll');
      } else {
        pagetopA.classList.remove('is-scroll');
      }
      
      // pagetopBが画面内に現れたらis-bottomクラスを追加
      if (pagetopB) {
        const pagetopBRect = pagetopB.getBoundingClientRect();
        const isPagetopBVisible = pagetopBRect.top <= window.innerHeight;
        
        if (isPagetopBVisible) {
          pagetopA.classList.add('is-bottom');
        } else {
          pagetopA.classList.remove('is-bottom');
        }
      }
    });
  }

  const anchorTarget = document.querySelector('.type_anchor .inner');
  if (anchorTarget) {
    const titles = document.querySelectorAll('.anchor');
    let anchorText = '';
    
    titles.forEach(title => {
      const id = title.getAttribute('id');
      const text = title.nextElementSibling.textContent;
      anchorText += `<li><a href="#${id}">${text}</a></li>`;
    });
    anchorTarget.innerHTML = `<ul>${anchorText}</ul>`;
    
  }

  const articleWrapper = document.querySelector('.article-wrapper');
  
  if (articleWrapper) {
    const articleContents = document.querySelector('.article-contents');
    const navAnchors = document.querySelector('.article-nav .anchors');
    
    if (articleContents && navAnchors) {
      const anchors = articleContents.querySelectorAll('a.anchor');
      let anchorLinks = '';
      console.log(anchors);
      
      anchors.forEach(anchor => {
        const id = anchor.getAttribute('id');
        const text = anchor.getAttribute('data-title');
        console.log(id, text);
        if (!text) return;
        anchorLinks += `<li><a href="#${id}" class="pArticleNav">${text}</a></li>`;
      });
      navAnchors.innerHTML = `${anchorLinks}`;
    }
  }

  // まずセレクタにマッチする要素が存在するか確認
  const anchors = document.querySelectorAll('a[href^="#"], a[href^="/#"], .anchors a');

  anchors.forEach(anchor => {
    
    anchor.addEventListener('click', function(event) {
      console.log('Anchor clicked:', this.getAttribute('href'));
      
      const href = this.getAttribute('href');
      if (!href || href.startsWith('mailto:') || !href.includes('#')) return;
      
      const targetId = href.includes('#') ? href.split('#')[1] : null;
      if (!targetId) return;
      
      const targetElement = document.getElementById(targetId);
      console.log('Target element:', targetId, targetElement);
      
      if (targetElement) {
        event.preventDefault();
        const nextElement = targetElement.nextElementSibling;
        if (nextElement) {
          const rectTop = nextElement.getBoundingClientRect().top + window.scrollY;
          // ウィンドウ幅に応じたオフセットの計算
          const offset = window.innerWidth < 768 
            ? (80 / 390) * window.innerWidth 
            : (120 / 1440) * Math.min(window.innerWidth, 1440);
          const targetPosition = rectTop - offset;
          console.log('.m_boxlistの上端位置:', rectTop);
          console.log('offset:', offset);
          console.log('スクロール先位置:', targetPosition);
          lenis.scrollTo(targetPosition);
        }
      }
    });
  });

  const faqElements = document.querySelectorAll('.type_faq');
  if (faqElements.length) {
    faqElements.forEach(faq => {
      const questions = faq.querySelectorAll('.pFaq');
      questions.forEach(question => {
        const q = question.querySelector('.q');
        q.addEventListener('click', () => {
          question.classList.toggle('is-active');
          const nextElement = q.nextElementSibling;
          
          if (nextElement.style.display === 'none' || !nextElement.style.display) {
            nextElement.style.display = 'block';
          } else {
            nextElement.style.display = 'none';
          }
        });
      });
    });
  }
});


/*-------------------------------------
 フッター固定ボタンのスクロール処理
--------------------------------------*/
let fixedFooterStartPos = 0;
const fixedFooterButton = document.getElementById('fixedFooterButton');

// jQueryを使わないES6の書き方に変更
window.addEventListener('scroll', () => {
  const winScrollTop = window.scrollY;
  const documentHeight = document.documentElement.scrollHeight;
  const footerHeight = document.querySelector('footer').offsetHeight;
  const windowHeight = window.innerHeight;
  
  if (fixedFooterButton) {
    if (winScrollTop > 500 && winScrollTop < documentHeight - footerHeight - windowHeight) {
      fixedFooterButton.classList.add('is-scroll');
    } else {
      fixedFooterButton.classList.remove('is-scroll');
    }
  }
  fixedFooterStartPos = winScrollTop;
});

/*
const tables = document.querySelectorAll('.table_set');
if (tables.length) {
  const handleTableOverflow = () => {
    tables.forEach(tableSet => {
      const existingOverflow = tableSet.querySelectorAll('.table_overflow');
      existingOverflow.forEach(overflow => overflow.remove());
      
      const tableSetWidth = tableSet.offsetWidth;
      const table = tableSet.querySelector('table');
      if (table) {
        const tableWidth = table.offsetWidth;
        console.log('tableWidth:', tableWidth);
        console.log('tableSetWidth:', tableSetWidth);
        if (tableWidth > tableSetWidth) {
          console.log('yes');
          const overflowDiv = document.createElement('div');
          overflowDiv.className = 'table_overflow';
          tableSet.insertBefore(overflowDiv, tableSet.firstChild);
        }
      }
    });
  };
  
  window.addEventListener('load', handleTableOverflow);
  window.addEventListener('resize', handleTableOverflow);
}
  */

const topSliderElement = document.querySelector('#topSlider .swiper');
const slideCount = topSliderElement ? topSliderElement.querySelectorAll('.swiper-slide').length : 0;

const topSlider = new Swiper('#topSlider .swiper', {
  loop: slideCount > 1,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  speed: 1000,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    768: {
      slidesPerView: 'auto',
      centeredSlides: true,
    }
  },
});